<template>
<div style="height:100%;" >
     <!-- <div  style="width: 100%;background-color: rgb(34, 34, 34);height:54px;">
        <span data-v-3c6d3300="" style="margin-left: 20px; float: left;">
            <img data-v-3c6d3300="" src="../assets/img/MKD-logo.png" style="max-height: 50px;cursor:pointer;" @click="toOurWeb()">
          
        </span>
    </div> -->
       <!-- <div style="width:70%;margin:auto;font-size: 1.17em;padding-top:50px;">
        
            <p>Dear Customers,</p> 
            Due to a very high demand to access to our platform, 
            We are sorry to inform you that new requests to access to our service for customers with less than 30 orders per day are currently closed. 
            We are sorry for the inconvenience.
            We're currently creating a new system to allow sellers with less than 30 orders per day to use our service, 
            It should be ready in 2 or 3 months.
            <p>Thank you for your understanding</p>
            <P style="text-align:right;margin-right:170px;">SR Team</P> 
        </div> -->
        <div style="display:flex;    min-height: 100%;">
             <div style="width:65%;">
            <div :style="login_cm_bj" class="customer-left-bg">
                <div class="login-opactiy"></div>
                <div class="systemTopText">
                    <div class="systemTopText-two">
                        <img src="../assets/img/shipping.png" alt="" style="width: 38%;margin-right: 2%;">has fast 
                    </div>
                    <div class="systemTopText-one">
                        warehousing service 
                    </div>
                    <div style="font-size: 26px;line-height: 2rem;margin-top:6%;"> 
                        <div>
                            Easily find products to sell online
                        </div>
                        <div>
                            ship them directly to your customers.
                        </div>
                    </div>
                        <div style="font-size: 22px;line-height: 2rem;margin-top:30%; font-weight: lighter;font-style: oblique;display:flex;"> 
                        <div style="display:inline-block;">
                             <img src="../assets/img/douhao.png" alt="" width="17px">
                        </div>
                        <div style="display:inline-block;font-weight: lighter;">
                            
                            <!-- <span style="font-size:50px">“</span> -->
                            It has never been easier to start your own dropshipping
                            <div>
                                business with Shipping Revolution. Shipping Revolution
                            </div>
                            <div>
                                lets you  find products on the world's most popular market-
                            </div>
                            <div>
                                places,add them to your e-commerce store, and ship them
                            </div>
                            <div style="display:flex;align-items: end;">
                                directly to your customers. 
                                <img src="../assets/img/douhao2.png" alt="" width="17px">
                                <!-- <span style="font-size:50px;display:inline-block;margin-left:15%">”</span> -->
                            </div>
                        </div>
                       
                      
                    </div>
                   
                </div>
            </div>
        </div>
         <div class="Systemlogin-container">
            
                <div class="systemLogin">
                <div style="width:100%;padding: 0 13%;">
                  
                    <div class="login-logo-img"> <img src="../assets/img/MKD-logo2.jpg" alt="" @click="toOurWeb()"> </div>
                    <el-form v-show="!forgetPwd" class="login-form" autoComplete="on" ref="loginForm" label-position="left">
                        <div class="title-container">
                            <h3 class="title" style="display:inline-block;color:#000;">{{gets('$客户端登录')}}</h3>
                            <lang-select class="set-language right lan"></lang-select>
                        </div>
                        <el-form-item prop="username">
                            <span class="svg-container svg-container_login">
                        <svg-icon icon-class="user" />
                        </span>
                            <div>{{gets('$登录名称')}}</div>
                            <el-input name="username" type="text" v-model="loginPage.LoginName.value" autoComplete="on" :placeholder="gets('$请输入登录名')" />
                        </el-form-item>
                        {{loginPage.LoginName.error}}
                        <el-form-item prop="password">
                            <span class="svg-container">
                            <svg-icon icon-class="password" />
                            </span>
                         <div>{{gets('$密码')}}</div>
                            <el-input name="password" type="password" @keyup.enter.native="login()" v-model="loginPage.Password.value" autoComplete="on" :placeholder="gets('$请输入密码')" />
                            <span class="show-pwd">
                        <svg-icon icon-class="eye" />
                        </span>
                        </el-form-item>
                        {{loginPage.Password.error}}
                    
                        
                        <div style="display:flex;width:100%;justify-content: space-between;margin-top:10px;">
                            <el-checkbox v-model="checked" name="记住密码">{{gets('$记住密码')}}</el-checkbox>
                            <div class="forgetPWD"  v-if="language=='EN'" @click="findPwd">Forgotten Password?</div>
                            <div class="forgetPWD"  v-if="language=='CN'" @click="findPwd">忘记密码？</div>
                        </div>
                        <el-form-item class="customer-btn">
                            <el-button type="success"  @click="login">{{gets('$登录')}}</el-button>
                            <!-- <el-button @click="Register">{{gets('$注册')}}</el-button> -->
                        </el-form-item>
                        <el-form-item class="customer-btn">
                            <div style="height:15px;" v-if="language=='CN'">没有账号？ <span style="color:#409EFF;cursor:pointer;" @click="showRegisterDialog=true">在此注册</span></div>
                            <div style="height:15px;" v-else>Don't have account？ <span style="color:#409EFF;cursor:pointer;" @click="showRegisterDialog=true">Sign Up Here</span></div>
                        </el-form-item>
                    </el-form>

                    <el-form v-show="forgetPwd" class="login-form" autoComplete="on" ref="loginForm" label-position="left">
                        <div class="title-container">
                            <h3 class="title" style="display:inline-block;color:#000;">{{gets('$找回密码')}}</h3>
                            <lang-select class="set-language right lan"></lang-select>
                        </div>
                        <el-form-item prop="useremail">
                            <span class="svg-container svg-container_login">
                                <svg-icon icon-class="user" />
                            </span>
                            <el-input name="useremail" type="text" @keyup.enter.native="resetPwd()" v-model="useremail" autoComplete="off" :placeholder="gets('$请输入电子邮件地址')" />
                        </el-form-item>
                        <!-- 验证码开始 -->
                        <!-- <el-form-item prop="usercode">
                            <span class="svg-container">
                                <svg-icon icon-class="password" />
                            </span>
                            <el-input name="usercode" type="text" @keyup.enter.native="resetPwd()"  v-model="usercode" autoComplete="off" :placeholder="gets('$输入{验证码}')" />
                            <span class="show-pwd">
                                <svg-icon icon-class="eye" />
                            </span>
                        </el-form-item> -->
                        <!-- <div class="login-code" @click="refreshCode()">
                            <s-identify :identifyCode="identifyCode"></s-identify>
                        </div> -->
                    <!-- 验证码结束 -->
                        <el-form-item class="customer-btn" style="margin-bottom:0px;">
                            <el-button type="success"  @click="resetPwd()">{{gets('$下一步')}}</el-button>
                        </el-form-item>
                        <el-form-item class="customer-btn">
                            <div style="height:15px; display: flex;justify-content: flex-end;" v-if="language=='CN'"> <span style="color:#409EFF;cursor:pointer;" @click="ReturnToLogin">返回登录页</span></div>
                            <div style="height:15px; display: flex;justify-content: flex-end;" v-else><span style="color:#409EFF;cursor:pointer;" @click="ReturnToLogin">Return</span></div>
                        </el-form-item>
                    </el-form>
                </div>
                </div>
        </div>
        </div>





        <!-- 注册弹窗 -->
        <el-dialog :visible.sync="showRegisterDialog" class="Register-dialog-wrapper"  :modal-append-to-body="true" :append-to-body="true" width="30%" title="Register" min-width="500px">
           
            <div class="Register1-dialog">
                <div class="Register1-dialog-img"> 
                    <img src="../assets/img/MKD-logo2.jpg" alt="" width="330px" @click="toOurWeb()"> 
                </div>
                <div class="Register1-dialog-form1">
                      <el-form class="Register1-dialog-form1-input"  autoComplete="on" ref="registerForm" label-position="left">
                        <div class="title-container">
                            <h3 class="title" style="color:#000;font-size:27px;">{{gets('$注册')}}</h3>
                            <lang-select class="set-language right lan"></lang-select>
                        </div>
                        <div v-if="FiretForm">
                             <el-form-item prop="username">
                                    <span class="svg-container svg-container_login">
                                <svg-icon icon-class="user" />
                                </span>
                                    <div><span class="red" style="margin-right:5px;">*</span>{{gets('$登录名')}}</div>
                                    <el-input name="username" type="text" v-model="RegisterParam.LoginName" autoComplete="on" :placeholder="gets('$请输入登录名')" />
                                </el-form-item>
                                
                                <el-form-item prop="password">
                                    <span class="svg-container">
                                    <svg-icon icon-class="password" />
                                    </span>
                                <div><span class="red" style="margin-right:5px;">*</span>{{gets('$密码')}}</div>
                                    <el-input name="password" type="password" @keyup.enter.native="login()" v-model="RegisterParam.Password" autoComplete="on" :placeholder="gets('$请输入密码')" />
                                    <span class="show-pwd">
                                <svg-icon icon-class="eye" />
                                </span>
                                </el-form-item>
                                <div style="display: flex;width:100%;">
                                    <el-form-item prop="FirstName" style="margin-right: 20px;width:50%;">
                                        <span class="svg-container svg-container_login"> </span>
                                        <div><span class="red" style="margin-right:5px;">*</span>{{gets('$姓')}}</div>
                                        <el-input aria-autocomplete="off" name="FirstName" type="text" v-model="RegisterParam.FirstName" autoComplete="on" :placeholder="gets('$请输入姓')" />
                                    </el-form-item>
                                    <el-form-item prop="LastName" style="width:50%;">
                                        <span class="svg-container svg-container_login"></span>
                                        <div><span class="red" style="margin-right:5px;">*</span>{{gets('$名')}}</div>
                                        <el-input name="LastName" type="text" v-model="RegisterParam.LastName" autoComplete="on" :placeholder="gets('$请输入名')" />
                                    </el-form-item>
                                </div>
                                <el-form-item prop="Country">
                                        <span class="svg-container svg-container_login"></span>
                                        <div><span class="red" style="margin-right:5px;">*</span>{{gets('$国家')}}</div>
                                       
                                         <el-select  :popper-append-to-body="false" v-model="RegisterParam.Country" clearable auto-complete filterable >
                                            <el-option v-for="item in CountryList" :value="item.value" :key="item.value" :label="item.label"></el-option>
                                            
                                        </el-select>
                                        
                                </el-form-item>
                                <el-form-item prop="Email">
                                        <span class="svg-container svg-container_login"></span>
                                        <div><span class="red" style="margin-right:5px;">*</span>{{gets('$邮箱')}}</div>
                                        <el-input name="Email" type="text" v-model="RegisterParam.Email" autoComplete="on" :placeholder="gets('$请输入邮箱')" />
                                </el-form-item>
                                <el-form-item prop="PhoneNumber">
                                        <span class="svg-container svg-container_login"></span>
                                        <div>{{gets('$手机')}}</div>
                                        <el-input name="PhoneNumber" type="text" v-model="RegisterParam.PhoneNumber" autoComplete="on" :placeholder="gets('$请输入手机')" />
                                </el-form-item>
                                <el-form-item class="Register1-form1-button" style="margin-bottom:0px;">
                                    <el-button  class="Register1-form1-button" @click="verifyForm1()">{{gets('$下一步')}}</el-button>
                                </el-form-item>
                        </div>
                        <div v-else>
                            <el-form-item prop="contactType">
                                    <div><span class="red" style="margin-right:5px;">*</span>{{gets('$联系软件')}}</div>
                                   <el-select  :popper-append-to-body="false" v-model="RegisterParam.contactType">
                                       <el-option v-for="item in options" :value="item.value" :key="item.value" :label="item.label"></el-option>
                                       
                                   </el-select>
                            </el-form-item>
                             <el-form-item prop="contactID">
                                    <span class="svg-container svg-container_login">
                                <svg-icon icon-class="user" />
                                </span>
                                    <div v-if="RegisterParam.contactType==1"><span class="red" style="margin-right:5px;">*</span>WeChat ID</div>
                                    <div v-else-if="RegisterParam.contactType==3"><span class="red" style="margin-right:5px;">*</span>WhatsApp ID</div>
                                    <div v-else><span class="red" style="margin-right:5px;">*</span>Contact phone number/method</div>
                                    
                                    <el-input name="contactID" type="text" v-model="RegisterParam.contactID" autoComplete="on" :placeholder="gets('$请输入联系ID')" />
                                </el-form-item>

                                <el-form-item prop="CurrencyID">
                                        <span class="svg-container svg-container_login"> </span>
                                        <div><span class="red" style="margin-right:5px;">*</span>{{gets('$币种')}}</div>
                                        
                                        <el-select  :popper-append-to-body="false" v-model="RegisterParam.CurrencyID">
                                            <el-option v-for="item in CurrencyList" :value="item.value" :key="item.value" :label="item.label"></el-option>
                                            
                                        </el-select>
                                </el-form-item>
                                <el-form-item prop="ServiceType">
                                        <span class="svg-container svg-container_login"></span>
                                        <div><span class="red" style="margin-right:5px;">*</span>{{gets('$服务类型')}}</div>
                                        <el-select  :popper-append-to-body="false" v-model="RegisterParam.ServiceType">
                                            <el-option v-for="item in ServeLevels" :value="item.value" :key="item.value" :label="item.label"></el-option>
                                            
                                        </el-select>
                                </el-form-item>
                               
                                <el-form-item prop="CusLevel">
                                        <span class="svg-container svg-container_login"></span>
                                        <div><span class="red" style="margin-right:5px;">*</span>{{gets('$客户等级')}}</div>
                                        <el-select  :popper-append-to-body="false" v-model="RegisterParam.CusLevel">
                                            <el-option v-for="item in UserLevels" :value="item.value" :key="item.value" :label="item.label"></el-option>
                                            
                                        </el-select>
                                </el-form-item>


                                 <el-form-item prop="CusLevel">
                                        <span class="svg-container svg-container_login"></span>
                                        <div><span class="red" style="margin-right:5px;">*</span>{{gets('$客户来源')}}</div>
                                        <el-select  :popper-append-to-body="false" v-model="RegisterParam.Source">
                                            <el-option v-for="item in SourceList" :value="item.value" :key="item.value" :label="item.label"></el-option>
                                            
                                        </el-select>
                                </el-form-item>


                               <el-form-item prop="Remarks">
                                    <span class="svg-container svg-container_login">
                                        <svg-icon icon-class="user" />
                                    </span>
                                    <div >{{gets('$备注')}}</div>
                                   
                                    
                                    <el-input name="Remarks" type="text" v-model="RegisterParam.Remarks" autoComplete="on" :placeholder="gets('$请输入备注')" />
                                </el-form-item>
                                <el-form-item class="Register1-form1-button Register1-form1-button2" style="margin-bottom:0px;">
                                    <el-button  class="Register1-form1-button" @click="aaa()">{{gets('$注册')}}</el-button>
                                </el-form-item>
                        </div>
                        
                     
                    </el-form>
                </div>
            </div>
          
            
             <!-- <register /> -->

        </el-dialog>


</div>
</template>
<!--
<template>
    <div>
        <el-select v-model="loginPage.Value" @change="LenChange()">
            <el-option v-for="item in ls" :value="item.Value" :label=" item.Text"></el-option>
        </el-select>
        <div class="container-fluid">
            <div style="margin: 100px auto; width: 500px;">
                <form role="form">
                    <form-group :placeholder="gets('$输入{登录名}')" :j="{rex:'w',tips:'登录名为必填'}" v-model="loginPage.LoginName.value" :error="loginPage.LoginName.error" :labelName="gets('$登录名')"></form-group>
                    <form-group :placeholder="gets('$输入{密码}')" :j="{rex:'w',tips:'密码为必填'}" :error="loginPage.Password.error" v-model="loginPage.Password.value" :labelName="gets('$密码')"></form-group>
                    <el-button @click="login()" class="btn btn-default">{{gets('$登录')}}</el-button>
                </form>
            </div>
        </div>
    </div>
</template>
-->
<script>
import { userRequest as UserRequest } from '@/request/user'
    import SIdentify  from '../components/verificationCode'
    import {
        languageRequest
    } from '../request/language'
    import {
        userRequest
    } from '../request/user.js'
    import {
        ToComponentData,
        CheckByConfig,
        ToSubmitData
    } from '../config/config.js'
    import {
        LoginPage
    } from '@/config/Sys/userConfig.js'
    import gets from '@/model/language'
    import { PublicDataRequest } from '@/request/PublicData'
    import { RegionRequest } from '@/request/Region'
    //Check() {
    //         ObjectCheck(this.j,this.value)
    //       },
    export default {
        components: { SIdentify },
        data() {
            return {
                options: [
                    {
                    value: 2,
                    label: 'Skype'
                    }, 
                    {
                    value: 1,
                    label: 'WeChat'
                    },
                    {
                    value: 3,
                    label: 'WhatsApp'
                    },
                    
                ],
                FiretForm:true,
                showRegisterDialog:false,
                checked:false,
                Value: 'EN',
                LoginName: '',
                Password: '',
                login_cm_bj: {
                    backgroundImage: "url(" + require("@/assets/img/customerLoginBG.jpg") + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    width: "100%",   
                    height:"100%",
                },
                forgetPwd:false,//忘记密码弹框
                identifyCodes: "1234567890",
                identifyCode: "",
                code:"",//text框输入的验证码
                useremail:"",//找回密码-电子邮箱地址
                usercode:"",//找回密码-验证码
                RegisterParam:{
                    Account:{
                        PaymentsType:0,//结算方式：0
                        CurrencyID:'',//币种ID
                    },
                    Customer:{
                        Remarks:"",
                        AddressLine:" ",
                        AuditNotes:" ",
                        Autherized:1,
                        City:" ",
                        Country:"",
                        CusLevel:"",
                        ServiceType: "",
                        Email:"",//注册邮箱
                        Name:" ",
                        Provine:" ",
                        ReferrerCode:"",
                        contactID:"",//注册邮箱
                        contactType:"",

                    },
                    Country:"",
                    CusLevel:"",//客户等级
                    CurrencyID:'',//币种ID
                    Email:"",//注册邮箱
                    FirstName:"",//注册邮箱
                    Gender:"",//注册邮箱
                    LastName:"",//注册邮箱
                    LoginName:"",//注册邮箱
                    Password:"",//注册邮箱
                    PhoneNumber:"",//注册邮箱
                    RPassword:"",//注册邮箱
                    UserType:1,//注册邮箱
                    contactType:"",
                    ServiceType: "",
                    contactID:"",//注册邮箱
                    Source:"",
                },
                CurrencyList:[],//币种数组
                ServeLevels:[{
                        label: gets("Dropshipping / Branding"),
                        value: '1'
                    },
                    {
                        label: gets("Amazon FBA"),
                        value: '2'
                    },
                    {
                        label:gets("Affiliation"),
                        value:'3'
                    },
                    {
                        label:gets("B2B Business"),
                        value:'4'
                    },
                ],
                SourceList:[                  
                    {
                        label: gets("Stacy agent"),
                        Value: '5'
                    },  
                    {
                        label: gets("Sean agent"),
                        value: '1'
                    },
                   
                    // {
                    //     label:gets("Cathy agent"),
                    //     value:'2'
                    // },
                    {
                        label:gets("Clement agent"),
                        value:'4'
                    },
                    {
                        label:gets("google ad discovery"),
                        value:'3'
                    },                   
                     {
                        label: gets("other"),
                        value: '0'
                    },           
                    ],
                UserLevels: [
                        {
                            label: gets("No orders"),
                            value: 0
                        },
                        {
                            label: gets("500 - 1000 orders per month"),
                            value: 1
                        },
                        {
                            label: gets("1000 - 3000 orders per month"),
                            value: 2
                        },
                        {
                            label: gets("3000 - 10000 orders per month"),
                            value: 3
                        },
                        {
                            label: gets("10000+ orders per month"),
                            value: 4
            
                }],
                CountryList:[],
                
            }
        },
        created() {
            //this.loginPage.Value = window.$.cookie('LanguagesTag')
            // console.log(window.location.href,"window.location.href")
            // console.log(window.location.href.indexOf("myshopify") >= 0)
            // if(window.location.href.indexOf("myshopify") >= 0){
            //     window.location.href="http://www.shippingrevolution.com/#/ShopifyLogin"
            //     window.open("http://service.shipping-revolution.com/#/Customerlogin");
            // }


            this.loginPage.Value = localStorage.getItem('LanguagesTag')
            if (!this.loginPage.Value) {
                this.loginPage.Value = 'EN';
                this.LenChange()
            }
          
           
            if(this.$route.query.LoginStatus==0){
                self.$message.success(self.gets("Your account has been confirmed. Please try to login"))
            }
            this.refreshCode()
            this.GetPublicDataByType()
            this.initRegionCountry()
        },
        mounted(){
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
            this.account(); //获取cookie的方法
        },
        computed: {
             language() {
                return localStorage.getItem('LanguagesTag')
                //return window.$.cookie('LanguagesTag')
                 
            },
            loginPage() {
                self = this;
                if (!self.$store.state.loginPage) {
                    var d = ToComponentData(LoginPage)
                    d.Value = 'CN'
                    self.$set(self.$store.state, "loginPage", d)
                }
                return self.$store.state.loginPage
            },
            ls() {
                window.rootVue = this;
                self = this;
                if (!self.$store.state.Languages) {
                    languageRequest.GetLanguages(function(d) {
                        self.$set(self.$store.state, "Languages", d)
                    })
                }
                return self.$store.state.Languages
            },
           
        },
        methods: {
            verifyForm1(){
                // console.log(this.RegisterParam.Customer.Country)
                // return
                 let self = this
                    if(self.RegisterParam.LoginName==""){
                        self.$message.error( gets("$请输入登录名") );
                        return
                    }else if(self.RegisterParam.Password==""){
                        self.$message.error( gets("$请输入密码") );
                        return
                    }else if(self.RegisterParam.FirstName==""){
                        self.$message.error( gets("$请输入姓") );
                        return
                    }else if(self.RegisterParam.LastName==""){
                        self.$message.error( gets("$请输入名") );
                        return
                    }else if(self.RegisterParam.Country==""){
                        self.$message.error( gets("$请选择国家") );
                        return
                    }else if(self.RegisterParam.Email==""){
                        self.$message.error( gets("$请输入邮箱") );
                        return
                    }
                    self.FiretForm=false

            },
            GetPublicDataByType(){
                PublicDataRequest.GetPublicDataByType(function (d) {
                let CurrencyList =[] 
                for (var i of d) {

                    i.Value = parseInt(i.Value)
                    CurrencyList.push({
                        value:i.Value,
                        label:i.Text
                    })
                }
               
                self.CurrencyList = CurrencyList
                // vueObj.$set(vueObj.$store.state, GN("UserCurrencyID"), d)
                console.log(self.CurrencyList)
                // if (callback) { callback(d) }
           
                }, 6)
            },
            initRegionCountry() {

                RegionRequest.SearchRegion(function (d) {
                    var arr = [];
                    for (var i of d.Records) {
                        i.Value = i.ID
                        arr.push({
                            value:i.Value,
                            label:i.EnName + "-" + i.CnName
                        })
                        // i.Text = i.EnName + "-" + i.CnName,
                        // i.Value = i.ID,
                        // label:i.Text
                        // //i.Value =i.EnName + "-" + i.CnName;
                        // arr.push(i)
                    }
                    self.CountryList = arr
                    // vueObj.$set(vueObj.$store.state, GN("OrderCountry"), arr)
                  
                }, {
                        PageSize: 10000,
                    })
            },

            aaa(){
                let self = this
                self.RegisterParam.Account.CurrencyID= self.RegisterParam.CurrencyID
                 self.RegisterParam.Customer.Country= self.RegisterParam.Country
                self.RegisterParam.Customer.CusLevel= self.RegisterParam.CusLevel
                self.RegisterParam.Customer.ServiceType= self.RegisterParam.ServiceType
                self.RegisterParam.Customer.Email= self.RegisterParam.Email
                self.RegisterParam.Customer.contactID= self.RegisterParam.contactID
                self.RegisterParam.Customer.contactType= self.RegisterParam.contactType
                self.RegisterParam.Customer.Remarks= self.RegisterParam.Remarks
                self.RegisterParam.RPassword= self.RegisterParam.Password
                self.RegisterParam.Customer.Source=self.RegisterParam.Source
                console.log(self.RegisterParam,self.RegisterParam.contactType)
                if(self.RegisterParam.contactType==""){
                    self.$message.error( gets("$请输入联系软件") );
                    return
                }else if(self.RegisterParam.contactID==""){
                    self.$message.error( gets("$请输入联系ID") );
                    return
                }else if(self.RegisterParam.CurrencyID==""){
                    self.$message.error( gets("$请选择币种") );
                    return
                }else if(self.RegisterParam.ServiceType==""){
                    self.$message.error( gets("$请选择服务类型") );
                    return
                }else if(self.RegisterParam.CusLevel===""){
                    self.$message.error( gets("$请选择客户等级") );
                    return
                }else if(self.RegisterParam.Source===""){

                    self.$message.error( gets("$请选择客户来源") );
                    return
                }
                


                    if (window.$.cookie("TG")) {
                        self.RegisterParam.Customer.ReferrerCode = window.$.cookie("TG");
                    }


                      
                            UserRequest.Register(function (d) {
                                if (d.Message == "OK") {
                                     self.$message({
                                        duration: 20000,
                                        message: 'Thank you for your registration! You should receive an email shortly with a confirmation link to activate your account.',
                                        type: 'success'
                                    }); 
                                    self.showRegisterDialog=false
                                     self.FiretForm=true
                                    self.RegisterParam.LoginName=""
                                      
                                    self.RegisterParam.Password=""
                                    self.RegisterParam.FirstName=""
                                    self.RegisterParam.LastName=""
                                    self.RegisterParam.Email=""
                                    self.RegisterParam.contactType=""
                                    self.RegisterParam.contactID=""
                                    self.RegisterParam.CurrencyID=""
                                    self.RegisterParam.CustomerType=""
                                    self.RegisterParam.CusLevel=""
                                    self.RegisterParam.Source=""                                   
                                    self.RegisterParam.PhoneNumber=""
                                    self.RegisterParam.Remarks=""
                                    
                                } else {
                                   self.$message.error(d.Message);
                                   self.FiretForm=true
                                }
                            }, self.RegisterParam)
                       

            },
            account() {
                // if (document.cookie.length <= 0) {
                console.log(this.getCookie("CustomerUsername"));
                // loginPage.LoginName.value
                if(this.getCookie("CustomerUsername")){

                }else{
                    this.checked=false
                }
                this.loginPage.LoginName.value = this.getCookie("CustomerUsername");
                console.log(this.loginPage.LoginName.value,"this.loginPage.LoginName.value")
                console.log(this.getCookie("CustomerUsername"))
                if(this.getCookie("CustomerUsername")&&this.getCookie("CustomerUsername")!=""){
                    this.checked=true
                    // this.loginPage.LoginName.value==""
                    // this.loginPage.Password.value==""
                }
                this.loginPage.Password.value = this.getCookie("CustomerPassword");
                // }
            },
             getCookie(name) {
                var arr = document.cookie.split(";");
                //["_ga=GA1.1.1756734561.1561034020", " mobile=123" password=456"]
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split("="); // ["_ga", "GA1.1.1756734561.1561034020"]
                    if (arr2[0].trim() == name) {
                    return arr2[1];
                    }
                }
            },
            clearCookie() {
                this.setCookie("", "", -1); //清除cookie
                },
                setCookie(c_name, c_pwd, exdate) {
                    //账号，密码 ，过期的天数
                    var exdate = new Date();
                
                    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdate); //保存的天数
                    document.cookie =
                        "CustomerUsername=" + c_name + ";path=/;expires=" + exdate.toLocaleString();
                    document.cookie =
                        "CustomerPassword=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString();
                },

            ReturnToLogin(){
                 location.reload()
            },
            findPwd(){
                this.forgetPwd = true
            },
             //验证码
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            },
        
            refreshCode() {
                this.identifyCode = "";
                this.makeCode(this.identifyCodes, 4);
            },
            makeCode(o, l) {
                for (let i = 0; i < l; i++) {
                    this.identifyCode += this.identifyCodes[
                    this.randomNum(0, this.identifyCodes.length)
                    ];
                }
               
            },

            // 重置密码
            resetPwd(){
                console.log(this.useremail)
                if(this.useremail==""){
                    self.$message.error(self.gets("$请输入电子邮箱地址"))
                    // this.forgetPwd = true
                    return
                }
                var reg = /^.+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/
                if(!reg.test(this.useremail)){
                    self.$message.error(self.gets("$电子邮件格式不正确"))
                    // this.forgetPwd = true
                    return
                }
                // if(this.usercode==""){
                //     self.$message.error(self.gets("$请输入验证码"))
                //     return
                // }
                // if(this.identifyCode!==this.usercode){
                //     this.usercode="";
                //     this.refreshCode();
                //     self.$message.error(self.gets("$请输入正确的验证码"))
                //     return
                // }
                
                userRequest.Sendmessagepassword(function(d) {
                    if (d.Message == "OK") {
                        //self.$router.push('/CustomerResetPwd')
                        //this.forgetPwd = true
                        self.useremail=""
                    self.$message({
                        duration: 20000,
                        message: self.gets("$操作成功,请注意查收邮件"),
                        type: 'success'
                    }); 
                    } else {
                       
                        self.$message.error(d.Message)
                    }
                }, {email:this.useremail})
                
               
                // self.$message.success(self.gets("$验证码对了！"))
            },
            toOurWeb(){
                window.location.href="http://service.shipping-revolution.com/"
            },
            gets(tag) {
                var d = gets(tag)
                return d;
            },
            Register() {
                self.$router.push('/Register')
            },
            LenChange() {

                localStorage.setItem('LanguagesTag', this.loginPage.Value)
                //window.$.cookie('LanguagesTag', this.loginPage.Value)

                    languageRequest.Change(function(d) {
                        window.location.reload()
                    }, this.loginPage.Value)
                
                
            },
            login() {

                this.$store.state.UserRights.Rights = [];
                window.ISGETRights = false;
                self = this;
                if (CheckByConfig(LoginPage, self.$store.state.loginPage)) {
                    if (self.checked == true) {
                        //存入cookie
                        self.setCookie(
                        self.$store.state.loginPage.LoginName.value,
                        encodeURI(self.$store.state.loginPage.Password.value),
                        7
                        ); //保存7天
                    } else {
                        self.clearCookie();
                    }
                    userRequest.login(function(d) {
                        if (d.Message == "OK") {
                            self.$router.push('/Main/Index')
                        } else {
                            self.$message.error(d.Message);
                        }
                    }, ToSubmitData(this.$store.state.loginPage))
                }
            }
        }
    }
    var self;
</script>


<style>
.Register1-form1-button{
    text-align: center;
    margin-top: 30px;
}

.Register1-form1-button .el-button{
    width: 70%;
    background-color: #5370F3 !important;
    color: #fff;
    border-radius: 25px;
}
.Register1-form1-button .el-button:focus{
    color: #fff !important; 
}
.Register1-form1-button2 .el-button{
    width: 70%;
    background-color: #00CC05 !important;
    color: #fff;
    border-radius: 25px;
}
.Register1-form1-button .el-button:hover {
    
    color: #fff;
}
.Register-dialog-wrapper .el-form-item{
    margin-bottom: 0px;
}
.Register1-dialog-form1-input{
    font-family: Helvetica, Helvetica;
    font-size: 20px;
    margin: 0 50px;
    color: #000 !important;
}
.Register-dialog-wrapper .Register1-dialog-img{
    padding-left: 70px;
}
.Register-dialog-wrapper .el-dialog{
    border-radius: 25px;
    margin-top: 9vh !important;
    min-width: 500px;
}
.Register-dialog-wrapper .el-dialog__header{
    display: none;
}
.Register-dialog-wrapper .el-input__inner{
    border-radius: 15px;
    background-color: #E8F0FD;
}
.customerlogin-container .el-button--success{
    background-color: #00CC05;
    width: 20%;
    margin-bottom: 30px;
    border-radius: 15px;
    float: right;
    margin-top: 20px;
}
    html {
        background-color: #F5F9FD;
        color: #666;
    }
.login-code{
    cursor: pointer;
    text-align: right;
    margin-bottom: 30px;
}
.forgetPWD{
    color:#409EFF;
    text-align:right;
    margin-bottom:20px;
    font-size:14px;
    cursor: pointer;
}
.s-canvas{
    height: 30px !important;
}
.login-container{
width:500px;
margin:auto;
    position: relative;
    margin-top: 0px !important;
    /* margin: 30px 0; */
   
   
    color: black;
}

 .customer-left-bg   .login-opactiy{
    width:100%;
    height: 100%;
    position: absolute;
    top:0;
    z-index: 0;
    background: #000;
    opacity: 0.3;
      border: 0 solid rgba(120, 130, 140, 0.13);
    border-radius: 5px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}
.login-container .login-form{
    padding: 20px 30px;
}
.login-container .login-form .title-container,.Register1-dialog-form1-input .title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.login-container .login-logo-img{
    padding-top: 30px;
    text-align: center;
    width: 100%;
    cursor: pointer;
}
.login-container .login-logo-img img{
    width: 240px;
}

    .right {
        float: right;

    }
.lan .el-dropdown-selfdefine  span
{
  color:#000 !important;;
}
.customer-btn{
    text-align: center;
}


</style>



// WEBPACK FOOTER //
// Customerlogin.vue?1077c30a